<template>
  <div class="text-h6 text-dark q-mb-sm">
    <q-skeleton type="text" class="text-h6" />
  </div>

  <div class="row">
    <div v-for="i in categoryCount" :key="i" class="col-4">
      <q-card
        flat
        bordered
        square
        class="q-pa-sm text-center full-height flex column items-center"
      >
        <q-skeleton
          type="rect"
          class="q-mb-sm q-mt-sm"
          style="width: 80%; height: 90px"
        />
        <q-card-section class="row q-pa-none full-width">
          <div class="text-primary text-weight-medium q-mb-xs">
            <q-skeleton type="text" class="text-weight-medium" />
          </div>
          <div class="text-primary text-weight-medium">
            <q-skeleton type="text" class="text-weight-medium" />
          </div>
        </q-card-section>
      </q-card>
    </div>
  </div>
</template>
<script setup lang="ts">
withDefaults(
  defineProps<{
    categoryCount?: number;
  }>(),
  {
    categoryCount: 12 as number
  }
);
</script>
